import { createContext, useReducer, useContext } from 'react';
import BotReducer from '../reducers/BotReducer';
import BotState from '../data/state/BotState';

const BotStateContext = createContext(BotState);
const BotDispatchContext = createContext(null);

function BotContextProvider({ children }) {
  const [state, dispatch] = useReducer(BotReducer, BotState);

  return (
    <BotStateContext.Provider value={state}>
      <BotDispatchContext.Provider value={dispatch}>
        {children}
      </BotDispatchContext.Provider>
    </BotStateContext.Provider>
  );
}

export default BotContextProvider;

export const useBotStateContext = () => useContext(BotStateContext);
export const useBotDispatchContext = () => useContext(BotDispatchContext);

